@if (categoryDropdown) {
  @if (localizationService.currentLocale$ | async; as locale) {
    <a [routerLink]="categoryDropdown.mainCategory ? (locale+categoryDropdown.mainPageUrl | translateRoute) : undefined"
      [class.pointer]="categoryDropdown.mainCategory"
      [class.navigation-collapsed]="navigationIsCollapsed"
      (click)="linkIsNotClicked()"
      (mouseenter)="linkHasClicked()"
      (mouseleave)="linkIsNotClicked()"
      class="dropdown-main"
      >
      {{ categoryDropdown.mainCategoryLabel ? (categoryDropdown.mainCategoryLabel | translate) : categoryDropdown.mainCategory }}
    </a>
  }
  <div (mouseenter)="linkHasClicked()"
    (mouseleave)="linkIsNotClicked()"
    [class.navigation-collapsed]="navigationIsCollapsed"
    [class.hide]="hideSubMenu"
    class="menu-container"
    >
    <div class="below-dropdown"></div>
    <div class="dropdown-container">
      <app-grid>
        <app-cell mobile="0:12">
          <div class="content">
            <div class="category-container">
              <div class="category-list">
                @if (categoryDropdown.mainPageUrl) {
                  <h3 (click)="linkIsNotClicked()"
                    [routerLink]="categoryDropdown.mainPageUrl | translateRoute"
                    class="subheading no-transform pointer"
                    >
                    {{ 'common.all' | translate }} {{ categoryDropdown.mainCategoryLabel ? (categoryDropdown.mainCategoryLabel | translate) : categoryDropdown.mainCategory }}
                  </h3>
                  <hr class="hr">
                }
                <div class="item-container"
                  [class.scrollable]="categoryDropdown.categories.length >= 6"
                  >
                  @for (category of categoryDropdown.categories; track category) {
                    <h3
                      (click)="linkIsNotClicked()"
                      [routerLink]="category.link! | translateRoute"
                      class="category-item subheading no-transform pointer"
                      >
                      {{ category.label ? (category.label | translate) : category.name }}
                    </h3>
                  }
                </div>
              </div>
            </div>
            <div class="highlight-grid">
              @for (highlight of categoryDropdown.highlights | slice:0:3; track highlight) {
                @if (highlight.image | imageSize : 330; as highlightImage) {
                  <a
                    (click)="linkIsNotClicked()"
                    [href]="highlight.link ? highlight.link : '#'"
                    [target]="highlight.target === 'BLANK' ? '_blank' : '_self'"
                    class="highlight-category"
                    >
                    <div class="highlight-label">
                      @if (highlight.highlight) {
                        <label
                          class="text-white small white-bold stretch text product-title"
                          >
                          {{ 'navigation.highlighted' | translate }}
                        </label>
                      }
                    </div>
                    <div class="title">
                      <h3 class="text-white">
                        {{ highlight.title }}
                      </h3>
                    </div>
                    <img [src]="highlightImage"
                      alt="Image of {{ highlight.title }}"
                      loading="lazy"
                      />
                  </a>
                }
              }
            </div>
          </div>
        </app-cell>
      </app-grid>
    </div>
  </div>
}
